import React from "react"

import { REGISTRATION_ENDPOINT } from "../../constants/urls"

interface SignupFormFieldsProps {
  cta?: string,
  code?: string,
  buttonColor?: string,
  buttonTextColor?: string,
  buttonHoverColor?: string,
  buttonActiveColor?: string,
}

class SignupFormFieldsInner extends React.PureComponent<SignupFormFieldsProps> {
  static defaultProps: SignupFormFieldsProps = {
    cta: "Get Started",
    code: "",
    buttonColor: "black",
    buttonTextColor: "white",
    buttonHoverColor: "black-secondary",
    buttonActiveColor: "gray-dark",
  }

  render() {
    const {
      cta,
      code,
      buttonColor,
      buttonTextColor,
      buttonHoverColor,
      buttonActiveColor,
    } = this.props

    return (
      <div className="w-full">
        <form className="form flex flex-col" action={REGISTRATION_ENDPOINT} method="POST">
          <div className="grid lg:grid-cols-3 gap-7">
            <div>
              <label htmlFor="registration_email" className="sr-only">Email</label>
              <input
                type="text"
                placeholder="Your Email Address"
                className="text-lg text-black-secondary border border-solid border-gray-400 w-full px-4 py-2 focus:border-primary shadow-inner"
                id="registration_email"
                name="registration[email]"
                required
              />
            </div>
            <div>
              <label className="sr-only" htmlFor="password">Password</label>
              <input
                type="password"
                placeholder="Create a Password"
                className="text-lg text-black-secondary border border-solid border-gray-400 w-full px-4 py-2 focus:border-primary shadow-inner"
                id="password"
                name="registration[password]"
                minLength={4}
                required
              />
            </div>
            <div className="mb-7">
              <label className="sr-only" htmlFor="zip_code">Zipcode</label>
              <input
                type="string"
                placeholder="Your ZIP code"
                className="text-lg text-black-secondary border border-solid border-gray-400 w-full px-4 py-2 focus:border-primary shadow-inner"
                id="zip_code"
                name="registration[zip_code]"
                maxLength={5}
                required
              />
            </div>
          </div>
          <div className="form-field">
            <input
              type="hidden"
              name="promo_code"
              value={code}
            />
          </div>
          <button
            type="submit"
            data-analytics="signup-cta"
            className={`inline-block text-center font-bold rounded-full leading-snug
              no-underline transition-all duration-200 ease-in-out
              active:[box-shadow:0px_4px_4px_0px_rgba(0,0,0,0.25)_inset]
              hover:no-underline text-[16px] border border-transparent
              mx-auto px-6 py-3.5 bg-${buttonColor} text-${buttonTextColor}
              hover:bg-${buttonHoverColor} active:bg-${buttonActiveColor}`}
          >
            {cta}
          </button>
        </form>
      </div>
    )
  }
}

export function SignupFormFields(props: SignupFormFieldsProps) {
  return <SignupFormFieldsInner {...props} />
}
